import React, {useState} from "react";
import cardImg from "./assets/img.png";
import axios from "axios";
import { useFeeData } from "wagmi";
import { useEffect } from "react";

const RecentDAO = () => {
  const [initialized, setInitialized] = useState(0);
  const [news, setNews] = useState([]);
  const [result, setResult] = useState([]);
  const StaticCard = () => {
    return(
      <a href="https://www.cnn.com/videos/business/2023/09/15/mary-barra-intv-compensation-gm-ceo-strike-cnntm-vpx.cnn" style={{border: "1px solid gray", borderRadius:"10px"}}>
        <div className="flex justify-center">
          <img className="w-full" style={{borderRadius:"10px 10px 0 0"}} src="https://media.cnn.com/api/v1/images/stellar/prod/230915085310-mary-barra-vpx.jpg" alt="" />
        </div>
        <div>
          <p className="text-res-xxs leading-[17px] px-2 mt-[8px]  font-semibold overflow-hidden max-h-[34px] whitespace-normal text-overflow-ellipsis"
            style={{ textOverflow: 'ellipsis', overflow: 'hidden', wordWrap:'break-word' }}>
              CNN.com
          </p>
          <a className="text-res-sm font-bold leading-[24px] px-2 overflow-hidden whitespace-nowrap" 
            style={{ display: 'inline-block', width: '100%', textOverflow: 'ellipsis', overflow: 'hidden' }}>
            GM CEO asked about her nearly $29 million in compensation as auto workers strike | CNN Business
          </a>
          <p className="text-res-xxs leading-[17px] px-2 overflow-hidden max-h-[34px] whitespace-normal text-overflow-ellipsis"
            style={{ textOverflow: 'ellipsis', overflow: 'hidden', wordWrap:'break-word' }}>
            The United Auto Workers union is on strike against General Motors, Ford and Stellantis after the union made ambitious demands in wages, benefits and job protections for its members. CNN’s Vanessa Yurkevich speaks to General Motors CEO Mary Barra about her compensation increase as workers strike.
          </p>
        </div>
      </a>
    )
  };
  const Card = ({id, link}) => {
    const [initialized, setInitialized] = useState(0);
    const getResultsToUse = () => {
      let {openGraph, htmlInferred, hybridGraph } = result;
      // protect against null values
      openGraph = openGraph || {};
      htmlInferred = htmlInferred || {};
      hybridGraph = hybridGraph || {};
  
      const site_name = openGraph.site_name || htmlInferred.site_name || hybridGraph.site_name;
      const title = openGraph.title || htmlInferred.title || hybridGraph.title;
      const url = openGraph.url || htmlInferred.url || hybridGraph.url;
      const favicon = htmlInferred.favicon || hybridGraph.favicon;
      const description = openGraph.description || htmlInferred.description || hybridGraph.description;
      const products = hybridGraph.products || htmlInferred.products;
  
      let image;
      if(openGraph.image){
        image = openGraph.image.url;
      } else {
        image = htmlInferred.image || hybridGraph.image
      }
  
      let video;
      if(openGraph.video){
        video = openGraph.video.secure_url
      } else {
        video = hybridGraph.video || htmlInferred.video;
      }
  
      return {
        site_name,
        title,
        url,
        favicon,
        image,
        description,
        video,
        products
      };
    };
    
    const site = encodeURIComponent(link);
    console.log(site);
    const url= `https://opengraph.io/api/1.1/site/${site}?app_id=129fd8b9-324b-4d53-8e7f-db380b00bfe1`;
    const initialize = async() =>(
      await fetch(url)
        .then((res) => res.json())
        .then((result) => {
          console.log(result);
          if(!result.error){
            setResult(result);
          } else {
            console.error(result)
          }
        })
    )
    if(!initialized)
    {
      initialize();
      setInitialized(!initialized);
    }
    return(
      <a key={id} href={link} style={{border: "1px solid white", borderRadius:"10px"}}>
        <div className="flex justify-center">
          <img className="w-full" src={getResultsToUse().image} alt="" />
        </div>
        <div>
          <a href={link} className="text-res-sm font-bold leading-[24px] mt-[8px] overflow-hidden whitespace-nowrap text-overflow-ellipsis">
            {getResultsToUse().title}...
          </a>
          <p className="text-res-xxs leading-[17px] overflow-hidden whitespace-nowrap text-overflow-ellipsis">{getResultsToUse().description}...</p>
        </div>
      </a>
    )
  };
  const fetchNews = async() =>{
    try {
      const response = await axios.get('http://localhost:5000/api/news/read');
      const data = response.data;
      console.log(response.data);
      setNews(data);
    } catch (error) {
      console.error('Error checking wallet:', error);
      throw error;
    }
  }
  if(!initialized){
    fetchNews();
    setInitialized(!initialized);
  }

  return (
    <div className="container mt-[70px] md:mt-[192px]">
      <div className="max-w-[1167px] mx-auto">
        <h2 className="text-res-lg font-extrabold text-center mb-[22px]">
          Recent DAO News
        </h2>
        <div className="grid gird-cols-1 md:grid-cols-2 lg:grid-cols-3  gap-x-[50px] gap-y-[40px]">
          {news.data?news.data.map(item => (
            <Card id={item.id} link={item.link}></Card>
          )):null}
          <StaticCard/>
        </div>
      </div>
    </div>
  );
};

export default RecentDAO;
